import { Flag, Package, Rocket, Zap } from 'lucide-react';
import * as React from 'react';

import { AnimatedCounter } from '@/components/animated-counter';

export function SectionStats() {
  return (
    <section className="redesign-container py-4">
      <dl className="grid grid-cols-2 gap-y-6 overflow-hidden rounded-2xl text-center lg:grid-cols-4">
        {stats.map((stat, index) => (
          <StatCard key={index} value={stat.value} label={stat.label} />
        ))}
      </dl>
    </section>
  );
}

const StatCard = ({
  value,
  label,
}: {
  value: string | React.ReactNode;
  label: string;
}) => {
  return (
    <div className="flex flex-col">
      <dt className="text-sm/6 font-semibold text-muted-foreground">{label}</dt>
      <dd className="order-first text-3xl font-bold tracking-tight">{value}</dd>
    </div>
  );
};

const stats = [
  {
    value: (
      <AnimatedCounter
        className="inline-flex items-center gap-2"
        prefix={<Flag className="size-6 text-primary" />}
        endValue={3.4}
        precision={1}
        suffix="M+"
      />
    ),
    label: 'Flags Served',
  },
  {
    value: (
      <AnimatedCounter
        className="inline-flex items-center gap-2"
        prefix={<Rocket className="size-6 text-primary" />}
        endValue={366}
        suffix="K+"
      />
    ),
    label: 'Flag Impressions',
  },
  {
    value: (
      <AnimatedCounter
        className="inline-flex items-center gap-2"
        prefix={<Package className="size-6 text-primary" />}
        endValue={5}
      />
    ),
    label: 'SDKs',
  },
  {
    value: (
      <AnimatedCounter
        className="inline-flex items-center gap-2"
        prefix={<Zap className="size-6 text-primary" />}
        endValue={15}
        suffix={<span className="text-xl">ms</span>}
      />
    ),
    label: 'P99 Latency',
  },
];
